export const OFFLINE_SYNC_HINT =
  "Offline – Änderungen werden beim nächsten Online-Gang synchronisiert.";

/** Banner bei echter Offline-Lage: nur Pflege und Aufnahmen werden nachgereicht. */
export const OFFLINE_BANNER_MESSAGE =
  "Offline – Pflegeeinträge und Aufnahmen werden später übertragen. Andere Änderungen sind offline nicht möglich.";

export const OFFLINE_BANNER_SIMULATED_MESSAGE =
  "Offline (simuliert) – Pflegeeinträge und Aufnahmen werden später übertragen. Andere Änderungen sind offline nicht möglich.";

/** Netzfehler, ohne dass der Vorgang eingereiht wurde. */
export const NO_CONNECTION_MESSAGE =
  "Keine Verbindung. Nicht gespeichert, bitte erneut versuchen.";

export function pullFailedToastText(transferred: number): string {
  const tail = "Neue Daten vom Server konnten nicht geladen werden.";
  if (transferred === 1) return `1 Vorgang übertragen. ${tail}`;
  if (transferred > 1) return `${transferred} Vorgänge übertragen. ${tail}`;
  return tail;
}
